<template>
  <div>
    <Card back>
      <template v-slot:header>
        <h4 class="d-inline">نکات کاری</h4>
        <a
          class="d-inline float-left mx-2 mt-1"
          href="javascript:;"
          @click="
            AddRow()
            requestAdd = []
          "
          data-title="ردیف جدید"
          v-if="!addRow & !$store.state.SeenWorkTip"
        >
          <h4>
            <i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i>
          </h4>
        </a>
      </template>

      <template v-slot:content>
        <div v-if="!addRow & !$store.state.SeenWorkTip">
          <BnpGrid Selectable :action="true" :propsRows="propsRows" :propsColumn="propsColumn" :NoRowNum="true" v-if="render">
            <template slot="Attachment" slot-scope="props">
              <div v-if="props.props.Attachment != null">
                <a :href="url + props.props.Attachment" class="text-success" target="_blank">دارد</a>
              </div>
              <div v-else>
                <p class="text-danger">ندارد</p>
              </div>
            </template>

            <template slot="Id" slot-scope="props">
              <div @click="seenWorkTip(props.props)" class="pointer" :class="[props.props.IsSeen ? ['text-success'] : '']">#{{ props.props.Id }}</div>
              <!-- <a :href="baseUrl + '/app/WorkTips#' + props.props.Id" :id="props.props.Id" @click="seenWorkTip(props.props)" class="pointer ChatroomVisted">#{{ props.props.Id }} </a> -->
            </template>

            <template slot="SolutionDescription" slot-scope="props">
              <div @click="showSolutionDescription(props.props.SolutionDescription)">
                {{ props.props.SolutionDescription.slice(0, 30) + (props.props.SolutionDescription.length > 30 ? '...' : '') }}
              </div>
            </template>

            <template slot="ProblemDescription" slot-scope="props">
              <div @click="showSolutionDescription(props.props.ProblemDescription)">
                {{ props.props.ProblemDescription.slice(0, 30) + (props.props.ProblemDescription.length > 30 ? '...' : '') }}
              </div>
            </template>

            <template slot="Subject" slot-scope="props">
              <div @click="showSolutionDescription(props.props.Subject)">
                {{ props.props.Subject.slice(0, 30) + (props.props.Subject.length > 30 ? '...' : '') }}
              </div>
            </template>

            <template slot="action-slot" slot-scope="props">
              <div class="row justify-content-center">
                <div>
                  <a href="javascript:;" class="badge text-center" @click="comment(props.props)">
                    <h6><span class="fa fa-comments-o hover-info"></span></h6>
                  </a>
                </div>

                <div>
                  <a href="javascript:;" class="badge text-center" @click="usersSenn(props.props)">
                    <h6><span class="fas fa-eye font-weight-bold hover-danger"></span></h6>
                  </a>
                </div>

                <div v-if="props.props.UserIdInsert == userId">
                  <a href="javascript:;" class="badge text-center">
                    <h6><span class="fa fa-pencil-square-o hover-info hover-info" @click="showEdit(props.props)"></span></h6>
                  </a>
                </div>

                <div v-if="props.props.UserIdInsert == userId">
                  <a href="javascript:;" class="badge text-center" @click="removeWorkTip(props.props)">
                    <h6><span class="fa fa-times hover-danger"></span></h6>
                  </a>
                </div>
              </div>
            </template>
          </BnpGrid>
        </div>

        <div v-if="addRow & !$store.state.SeenWorkTip" :id="$route.name">
          <form id="CreateTilcket">
            <div class="row mt-3">
              <div class="col-md-2 col-12"></div>
              <div class="col-md-8 col-12">
                <div class="mt-3">
                  <small id="LblSubject">موضوع</small>
                  <input @keypress="$ValidLenght($event, 400)" type="text" v-model="requestAdd.Subject" class="form-control required mt-1" autocomplete="off" />
                </div>
              </div>
              <div class="col-md-2 col-12"></div>
            </div>

            <div class="row">
              <div class="col-md-2 col-12"></div>
              <div class="col-md-8 col-12">
                <div class="mt-3">
                  <small id="LblProblemDescription">شرح مشکل</small>
                  <textarea @keypress="$ValidLenght($event, 2000)" id="txtSubject" type="text" v-model="requestAdd.ProblemDescription" class="form-control required mt-1" autocomplete="off" />
                </div>
              </div>
              <div class="col-md-2 col-12"></div>
            </div>

            <div class="row">
              <div class="col-md-2 col-12"></div>
              <div class="col-md-8 col-12">
                <div class="mt-3">
                  <small id="LblSolutionDescription">شرح راه حل</small>
                  <textarea @keypress="$ValidLenght($event, 2000)" id="txtSubject" type="text" v-model="requestAdd.SolutionDescription" class="form-control required mt-1" autocomplete="off" />
                </div>
              </div>
              <div class="col-md-2 col-12"></div>
            </div>

            <div class="row">
              <div class="col-md-2 col-12"></div>
              <div class="col-md-4 col-12">
                <div class="mt-3">
                  <small>نوع نکته</small>
                  --- {{ requestAdd.TipTypeGrp51 }}---
                  <SearchableCombo :edit="false" :grp="56" :code="null" @ResultCombo="GetResultGrp51" :rownumintable="3" :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'Id'" :keyItem="'Name'" :defaultvalue="requestAdd.TipTypeGrp51" :ClassProps="'required'"></SearchableCombo>
                </div>
              </div>
              <div class="col-md-4 col-12 mt-3">
                <small>فایل پیوست</small>
                <input type="file" class="form-control" id="inputAttachment" />
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-2 col-12"></div>
              <div class="col-md-8 col-12 d-flex justify-content-center">
                <button class="btn btn-danger p-2 col ml-3" @click.prevent="addRow = false" style="width: 24%">بازگشت</button>
                <button class="btn btn-success p-2 col" v-if="!isEdit" @click.prevent="submitTip()" style="width: 24%">ثـبـت</button>
                <button class="btn btn-primary p-2 float-left" v-if="isEdit" @click.prevent="editTip()" style="width: 48%">ویرایش</button>
              </div>
              <div class="col-md-2 col-12"></div>
            </div>
          </form>
        </div>

        <div v-if="$store.state.SeenWorkTip">
          <SeenWorkTip :WorkTipModel="seenWorkTipModel" @showCommnetEmit="showCommnetEmit"></SeenWorkTip>
        </div>
      </template>
    </Card>

    <!-- Modal -->
    <WorkTipsComment v-if="$store.state.Modal" :InheritanceTheme="true" :size="'lg'" :noHeader="false">
      <template v-slot:header>
        <h4 class="d-inline">جزئیات نظرات</h4>
      </template>
      <template v-slot:body>
        <a class="d-inline float-left mx-2" href="javascript:;" @click="addComment()" data-title="کامنت جدید" v-if="!addCommentShow">
          <h4>
            <i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i>
          </h4>
        </a>
        <a class="d-inline float-left mx-2" href="javascript:;" v-if="addCommentShow" @click="addCommentShow = false">
          <h4>
            <i class="fad fa-arrow-left" style="color: var(--logo-color) !important"></i>
          </h4>
        </a>
        <div class="mt-2">
          <div v-if="!addCommentShow">
            <BnpGrid :action="true" :propsRows="propsRowsComment" :propsColumn="propsColumnComment" :NoRowNum="true" v-if="render">
              <template slot="Mark" slot-scope="props">
                <star-rating :show-rating="false" :star-size="15" :inline="true" v-model="props.props.Mark" :read-only="true"> </star-rating>
              </template>

              <template slot="SolutionDescription" slot-scope="props">
                <div @click="showSolutionDescription(props.props.SolutionDescription)" class="pointer">
                  {{ props.props.SolutionDescription.slice(0, 30) + (props.props.SolutionDescription.length > 30 ? '...' : '') }}
                </div>
              </template>

              <template slot="action-slot" slot-scope="props">
                <div class="row justify-content-center">
                  <div v-if="props.props.UserIdInsert == userId">
                    <a href="javascript:;" class="badge text-center" @click="removeComment(props.props)">
                      <h6><span class="fa fa-times hover-danger"></span></h6>
                    </a>
                  </div>
                </div>
              </template>
            </BnpGrid>
          </div>

          <div v-if="addCommentShow">
            <div class="row justify-content-center">
              <div class="col-md-10 col-12">
                <div class="mt-3">
                  <small id="LblTitle" class="h6">شرح نظر</small>
                  <textarea @keypress="$ValidLenght($event, 2000)" id="txtSubject" type="text" v-model="tblComment.SolutionDescription" class="form-control required mt-1" autocomplete="off" />
                </div>
              </div>
            </div>
            <div class="row justify-content-center mt-3">
              <star-rating :show-rating="false" :star-size="15" :inline="true" v-model="tblComment.Mark" :read-only="false"> </star-rating>
            </div>
            <div class="row justify-content-center">
              <button class="btn btn-success col-4 mt-3" @click="submitComment()">ثبت نظر</button>
            </div>
          </div>
        </div>

        <!-- ModalMd -->
        <WorkTipsComment v-if="showFullText" :InheritanceTheme="true" :size="'md'">
          <template v-slot:headerMd>
            <button class="fas fa-times btn-danger" @click="showFullText = false"></button>
          </template>
          <template v-slot:body>
            <p>{{ FullText }}</p>
          </template>
        </WorkTipsComment>
        <!-- ModalMd -->
      </template>
    </WorkTipsComment>
    <!-- EndModal -->

    <!-- ModalMd -->
    <WorkTipsComment v-if="showFullText" :InheritanceTheme="true" :size="'md'">
      <template v-slot:headerMd>
        <button class="fas fa-times btn-danger" @click="showFullText = false"></button>
      </template>
      <template v-slot:body>
        <p>{{ FullText }}</p>
      </template>
    </WorkTipsComment>
    <!-- ModalMd -->

    <WorkTipsComment v-if="usersSeenModal" :InheritanceTheme="true" :size="'md-header'" :noHeader="true">
      <template v-slot:headerMd>
        <div class="justify-content-start col-12">
          <h4 class="d-inline">مشاهده کنندگان</h4>
        </div>
        <button class="fas fa-times btn-danger" @click="usersSeenModal = false"></button>
      </template>
      <template v-slot:body>
        <div class="row p-3">
          <div class="">
            <span class="badge border m-1 p-2" v-for="(item, index) in usersSeenRes" :key="index"> {{ item.NamFam }} &nbsp;&nbsp; </span>
          </div>
        </div>
      </template>
    </WorkTipsComment>
  </div>
</template>

<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import WorkTipsComment from '../WorkTips/WorkTipsComment'
import SeenWorkTip from '../WorkTips/SeenWorkTip'

export default {
  components: { Card, BnpGrid, SearchableCombo, WorkTipsComment, SeenWorkTip },

  data() {
    return {
      commentPage: false,
      subject: '',
      render: true,
      propsColumn: [
        { name: 'Id', label: 'شناسه', visibility: true },
        { name: 'Subject', label: 'موضوع', visibility: true },
        { name: 'ProblemDescription', label: 'شرح مشکل', visibility: true },
        { name: 'SolutionDescription', label: 'شرح راه حل', visibility: true },
        { name: 'Attachment', label: 'پیوست', visibility: true },
        { name: 'NamFam', label: 'ایجاد کننده', visibility: true },
        { name: 'TipTypeName', label: 'نوع نکته', visibility: true },
      ],
      propsColumnComment: [
        { name: 'Id', label: 'شناسه', visibility: true },
        { name: 'NamFam', label: 'نظر دهنده', visibility: true },
        { name: 'SolutionDescription', label: 'شرح نظر', visibility: true },
        { name: 'DateTimeInsert', label: 'تاریخ', visibility: true },
        { name: 'Mark', label: 'نمره', visibility: true },
      ],
      propsRows: [],
      propsRowsComment: [],
      url: this.$cookies.get('URL'),
      temp: [],
      addRow: false,
      requestAdd: {
        Subject: null,
        ProblemDescription: null,
        SolutionDescription: null,
        Attachment: null,
        NamFam: null,
        TipTypeName: null,
        TipTypeGrp51: null,
      },
      acceptFile: ['.jpg', '.gif', '.jpeg', '.png', '.pdf', '.bmp', '.txt', '.zip', '.rar'],
      userId: this.$session.get('UserInfo').tblUserId,
      tblUserGrpIdInsert: this.$session.get('UserInfo').tblUserGrpId,
      isEdit: false,
      addCommentShow: false,
      tblComment: [],
      tblWorkTip: [],
      selectIdTblWorkTip: null,
      isCreatorWorkTip: false,
      showFullText: false,
      FullText: '',
      addRowFromDashbord: this.$route.params.addRowFromDashbord,
      pushFromDashbordId: this.$route.params.pushFromDashbordId,
      seenWorkTipModel: {},
      baseUrl: '',
      usersSeenModal: false,
      usersSeenRes: [],
    }
  },
  mounted() {
    this.baseUrl = window.location.origin
    this.$store.state.SeenWorkTip = false
    this.GetWorkTips()
    this.$store.state.Modal = false
    if (this.addRowFromDashbord) {
      this.AddRow()
      this.requestAdd = []
    }
  },
  methods: {
    showCommnetEmit(item){
      this.comment(item)
    },
    usersSenn(item) {
      this.usersSeenModal = true
      let DataaxiosDepUser = {
        Action: 'WorkTips/GetUserSeenTip',
        Method: 'Post',
        ArryfildValue: {
          TblUserIdSeen: this.userId,
          TblUserGrpIdInsert: this.tblUserGrpIdInsert,
          Id: item.Id,
        },
      }

      this.$PostData(DataaxiosDepUser)
        .then((res) => {
          this.usersSeenRes = res
        })
        .catch((err) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
          console.error('CATCH', err)
        })
    },
    seenWorkTip(item) {
      let DataaxiosDepUser = {
        Action: 'WorkTips/SeenWorkTip',
        Method: 'Post',
        ArryfildValue: {
          TblUserIdSeen: this.userId,
          TblUserGrpIdInsert: this.tblUserGrpIdInsert,
          TblWorkTipsId: item.Id,
        },
      }
      this.$store.state.SeenWorkTip = true
      this.seenWorkTipModel = item
      this.$PostData(DataaxiosDepUser)
        .then((res) => {
          let find = this.propsRows.find((x) => x.Id == item.Id)
          find.IsSeen = true
          this.render = false
          this.$nextTick(() => {
            this.render = true
          })
        })
        .catch((err) => {
          console.error('CATCH', error)
        })
    },
    showSolutionDescription(text) {
      this.showFullText = true;
      this.FullText = text;
    },
    subitMark(item) {
      if (item.Mark < 0 || item.Mark > 10 || item.Mark == null) {
        this.$mySweetDefaultTost('', 'بازه ی نمره بین 0 تا 10 میباشد', 'info', 3000)
        return
      }
      let DataaxiosDepUser = {
        Action: 'WorkTips/SetMark',
        Method: 'Post',
        ArryfildValue: {
          Id: item.Id,
          Mark: item.Mark,
          TblUserGrpIdLastEdit: this.tblUserGrpIdInsert,
        },
      }

      this.$PostData(DataaxiosDepUser)
        .then((res) => {
          if (res.Status == 'Ok') {
            this.$toasted.success('نمره شما با موفقیت ثبت شد', {
              action: {
                text: 'بستن',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                },
              },
            })
            let find = this.propsRowsComment.find((x) => x.Id == item.Id)
            find.Mark = item.Mark
          }
        })
        .catch((err) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
          console.error('CATCH', error)
        })
    },
    submitComment() {
      let DataaxiosDepUser = {
        Action: 'WorkTips/AddCommnet',
        Method: 'Post',
        ArryfildValue: {
          TblWorkTipId: this.selectIdTblWorkTip,
          SolutionDescription: this.tblComment.SolutionDescription,
          UserIdInsert: this.userId,
          TblUserGrpIdInsert: this.tblUserGrpIdInsert,
          Mark: this.tblComment.Mark,
        },
      }

      this.$PostData(DataaxiosDepUser)
        .then((res) => {
          this.$toasted.success('نظر شما با موفقیت ثبت شد', {
            action: {
              text: 'بستن',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              },
            },
          })
          this.tblComment.SolutionDescription = ''
          this.tblComment.Mark = 0
          this.propsRowsComment.unshift(res.newRecord)
          this.render = false
          this.$nextTick(() => {
            this.render = true
          })
          this.addCommentShow = false
        })
        .catch((error) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
          console.error('CATCH', error)
        })
        .finally(() => {
          this.render = false
          this.$nextTick(() => {
            this.render = true
          })
        })
    },
    addComment() {
      this.addCommentShow = true
    },
    GetResultGrp51(data) {
      if (data.id != null) {
        this.requestAdd.TipTypeGrp51 = data.id
      }
      // console.log(this.requestAdd.TipTypeGrp51)
    },
    removeComment(item) {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success mx-1',
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      })
      swalWithBootstrapButtons
        .fire({
          title: 'اطمینان دارید؟',
          text: 'از حذف ' + '؟',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'بله، حذف شود',
          cancelButtonText: 'لغو',
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            var DataaxiosDepUser = {
              Action: 'WorkTips/deleteComment',
              Method: 'Delete',
              ArryfildValue: {
                Id: item.Id,
              },
            }
            this.$PostData(DataaxiosDepUser)
              .then((response) => {
                if (response.Status == 'Ok') {
                  var record = this.propsRowsComment.find((x) => x.Id == item.Id)
                  var index = this.propsRowsComment.indexOf(record)
                  this.propsRowsComment.splice(index, 1)
                  this.render = false
                  this.$nextTick(() => {
                    this.render = true
                  })
                  this.$toasted.success("حذف با موفقیت صورت گرفت", {
                    action: {
                      text: "بستن",
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                      },
                    },
                  });
                } else {
                  swalWithBootstrapButtons.fire('', 'حذف کامنت به دلیل رابطه با سایر جداول صورت نگرفت', 'info')
                }
              })
              .catch((error) => {
                console.error('CATCH', error)
                swalWithBootstrapButtons.fire('', 'عملیات با خطا مواجه شد', 'error')
              })
          }
        })
    },
    removeWorkTip(item) {
      this.$store.state.OldDataForLog = JSON.stringify(item)
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success mx-1',
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      })
      swalWithBootstrapButtons
        .fire({
          title: 'اطمینان دارید؟',
          text: 'از حذف ' + item.Subject + '؟',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'بله، حذف شود',
          cancelButtonText: 'لغو',
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            var DataaxiosDepUser = {
              Action: 'WorkTips',
              Method: 'Delete',
              ArryfildValue: {
                Id: item.Id,
              },
            }
            this.$PostData(DataaxiosDepUser)
              .then((response) => {
                if (response.Status == 'Ok') {
                  this.$SetLog(this.requestAdd, 1)
                  var record = this.propsRows.find((x) => x.Id == item.Id)
                  var index = this.propsRows.indexOf(record)
                  this.propsRows.splice(index, 1)
                  this.render = false
                  this.$nextTick(() => {
                    this.render = true
                  })
                  this.$toasted.success('حذف با موفقیت صورت گرفت', {
                    action: {
                      text: 'بستن',
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0)
                      },
                    },
                  })
                } else {
                  swalWithBootstrapButtons.fire('', 'حذف به دلیل رابطه با سایر جداول صورت نگرفت', 'info')
                }
              })
              .catch((error) => {
                console.error('CATCH', error)
                swalWithBootstrapButtons.fire('', 'عملیات با خطا مواجه شد', 'error')
              })
          }
        })
    },
    GetWorkTips() {
      let DataaxiosDepUser = {
        Action: 'WorkTips/GetWorkTips',
        Method: 'Get',
        ArryfildValue: null,
      }

      this.$PostData(DataaxiosDepUser)
        .then((res) => {
          this.propsRows = res.BvWorktips
          this.propsRows.forEach((workTip) => {
            workTip.ListUsers = []
            res.TblWorkTipSeen.forEach((tipSeen) => {
              if (workTip.Id == tipSeen.TblWorkTipsId) {
                workTip.ListUsers.push(tipSeen.TblUserIdSeen)
              }
            })
          })

          this.propsRows.forEach((el) => {
            el.IsSeen = false
            el.ListUsers.forEach((el2) => {
              if (el2 == this.userId) {
                el.IsSeen = true
              }
            })
          })

          if (this.pushFromDashbordId != undefined) {
            let find = this.propsRows.find((x) => x.Id == this.pushFromDashbordId)
            find.IsSeen = true
            this.render = false
            this.$nextTick(() => {
              this.render = true
            })
            this.seenWorkTip(find)
          }
        })
        .catch((error) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
          console.error('CATCH', error)
        })
        .finally(() => {
          this.render = false
          this.$nextTick(() => {
            this.render = true
          })
        })
    },
    editTip() {
      if (!this.$ValidForm(this.$route.name)) {
        return
      }
      let attachment = document.getElementById('inputAttachment').files[0]
      if (attachment != undefined) {
        if (Math.round(attachment.size / 1000 > 10100)) {
          this.$mySweetDefaultTost('', 'حجم فایل پیوست باید کمتر از 10 مگ باشد', 'info', 2000)
          return
        }
      }
      let formData = new FormData()
      formData.append('Subject', this.requestAdd.Subject)
      formData.append('ProblemDescription', this.requestAdd.ProblemDescription)
      formData.append('SolutionDescription', this.requestAdd.SolutionDescription)
      formData.append('UserIdInsert', this.userId)
      formData.append('File', attachment)
      formData.append('TblUserGrpIdLastEdit', this.TblUserGrpIdInsert)
      formData.append('Id', this.requestAdd.Id)
      formData.append('TipTypeGrp51', this.requestAdd.TipTypeGrp51)

      let DataaxiosDepUser = {
        Action: 'WorkTips/EditWorkTip',
        Method: 'POST',
        ArryfildValue: formData,
      }

      this.$PostFormData(DataaxiosDepUser)
        .then((res) => {
          if (res.Status == 'Ok') {
            this.$mySweetDefaultTost('عملیات موفق', res.Message, 'success', 2000)
            this.$SetLog(this.requestAdd, 0)
            this.requestAdd = {
              Subject: null,
              ProblemDescription: null,
              SolutionDescription: null,
              Attachment: null,
              NamFam: null,
              TipTypeName: null,
            }
            this.addRow = false
            this.isEdit = false
            this.GetWorkTips()
            this.pushFromDashbordId = undefined
          } else {
            this.$mySweetDefaultTost('', res.Message, 'info', 2000)
          }
        })
        .catch((err) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
          console.error(err)
        })
    },
    showEdit(props) {
      this.addRow = true
      this.isEdit = true
      this.requestAdd.Subject = props.Subject
      this.requestAdd.SolutionDescription = props.SolutionDescription
      this.requestAdd.ProblemDescription = props.ProblemDescription
      this.requestAdd.Id = props.Id
      this.requestAdd.TipTypeGrp51 = props.TipTypeGrp51
      this.$store.state.OldDataForLog = JSON.stringify(props)
    },
    submitTip() {
      if (!this.$ValidForm(this.$route.name)) {
        return
      }
      let attachment = document.getElementById('inputAttachment').files[0]
      if (attachment != undefined) {
        if (Math.round(attachment.size / 1000 > 10100)) {
          this.$mySweetDefaultTost('', 'حجم فایل پیوست باید کمتر از 10 مگ باشد', 'info', 2000)
          return
        }
      }
      let formData = new FormData()
      formData.append('Subject', this.requestAdd.Subject)
      formData.append('ProblemDescription', this.requestAdd.ProblemDescription)
      formData.append('SolutionDescription', this.requestAdd.SolutionDescription)
      formData.append('UserIdInsert', this.userId)
      formData.append('File', attachment)
      formData.append('TblUserGrpIdInsert', this.tblUserGrpIdInsert)
      formData.append('TipTypeGrp51', this.requestAdd.TipTypeGrp51)

      let DataaxiosDepUser = {
        Action: 'WorkTips/AddWorkTip',
        Method: 'POST',
        ArryfildValue: formData,
      }

      this.$PostFormData(DataaxiosDepUser)
        .then((res) => {
          if (res.Status == 'Not Ok') {
            this.$mySweetDefaultTost('عملیات ناموفق', res.Message, 'error', 2000)
          }
          if (res.Status == 'Ok') {
            this.$mySweetDefaultTost('عملیات موفق', res.Message, 'success', 2000)
            ;(this.requestAdd = {
              Subject: null,
              ProblemDescription: null,
              SolutionDescription: null,
              Attachment: null,
              NamFam: null,
              TipTypeName: null,
            }),
              (this.addRow = false)
            this.pushFromDashbordId = undefined
            this.GetWorkTips()
          }
        })
        .catch((err) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
          console.error(err)
        })
    },
    AddRow() {
      this.addRow = true
    },
    comment(item) {
      this.subject = item.Subject
      this.$store.state.Modal = true
      this.addCommentShow = false
      this.selectIdTblWorkTip = item.Id

      let DataaxiosDepUser = {
        Action: 'WorkTips/GetComments',
        Method: 'Post',
        ArryfildValue: {
          Id: item.Id,
        },
      }
      this.$PostData(DataaxiosDepUser)
        .then((res) => {
          this.propsRowsComment = res
          if (item.TblUserGrpIdInsert == this.tblUserGrpIdInsert) {
            this.isCreatorWorkTip = true
          } else {
            this.isCreatorWorkTip = false
          }
          this.tblComment.SolutionDescription = ''
        })
        .catch((error) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
          console.error('CATCH', error)
        })
        .finally(() => {
          this.render = false
          this.$nextTick(() => {
            this.render = true
          })
        })
    },
    back() {
      this.propsRows = this.temp
      this.render = false
      this.$nextTick(() => {
        this.render = true
      })
    },
  },
}
</script>

<style scoped>
textarea {
  resize: none;
  height: 120px !important;
}

.pointer {
  cursor: pointer;
}

.ChatroomVisted:visited {
  color: #21ae8c !important;
}
</style>
